import { render, staticRenderFns } from "./newpassword.vue?vue&type=template&id=7f5701a7"
import script from "./newpassword.vue?vue&type=script&lang=js"
export * from "./newpassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports